import { dispatch, state } from "__common/store";
import { BACKGROUND_SET_LOW_EDGE_TO_ROOF } from "../backgroundActions";

export const loadLowEdgeToRoof = () => {
  const { background: { selectedRoofId }, drawingManager: { roofs } } = state();
  const lowEdgeToRoof = roofs[selectedRoofId].lowEdgeToRoof;
  dispatch(BACKGROUND_SET_LOW_EDGE_TO_ROOF(lowEdgeToRoof??50));
};
